var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","stroke-width":"0"}}),_c('path',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m6.75 10.813 2.438 2.437c1.218-4.469 4.062-6.5 4.062-6.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }